// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.header-hidden .header-container{max-height:0;overflow:hidden}.header-hidden .sticky-bar-container{top:0}@media(min-width:768px){.header-hidden .sticky-bar-container{top:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
